import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import { Dispatch } from '../../../store';
import { Button } from 'antd';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';

const useStyles = makeStyles(({ spacing }) => ({
  back: {
    fontSize: 25
  },
  left: { float: 'left' },
  right: { float: 'right' },
  backButton: {
    margin: spacing(1)
  }
}));

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    collapseDrawer: d.drawer.collapseDrawer,
    getMap: () => d.infrastructureMap.getMap(undefined as any)
  };
};

type connectedProps = ReturnType<typeof mapDispatch>;

enum Modes {
  back = 'back',
  expand = 'expand'
}

type IModes = {
  [key in Modes]: {
    handle?: () => void;
    iconName: string;
  };
};

type IProps = {
  toUrl?: string;
  onClose?: () => void;
} & connectedProps;

const DrawerAction: FC<IProps> = ({ toUrl = '', onClose, collapseDrawer, getMap }) => {
  const classes = useStyles();
  const history = useHistory();

  const handle = () => {
    if (toUrl) {
      history.push(toUrl);
    } else {
      history.goBack();
    }

    if (onClose) {
      onClose();
    }
  };

  const modes: IModes = {
    back: {
      handle,
      iconName: 'back'
    },
    expand: {
      handle: () => {
        collapseDrawer();
        getMap();
      },
      iconName: 'clear'
    }
  };

  return (
    <div className={classes.backButton}>
      <div className={classes.left}>
        <Button
          type={'text'}
          onClick={modes.expand.handle}
          icon={<CloseOutlined className={classes.back} />}
        />
      </div>
      <div className={classes.right}>
        <Button
          type={'text'}
          onClick={modes.back.handle}
          icon={<ArrowLeftOutlined className={classes.back} />}
        />
      </div>
    </div>
  );
};

const withConnect = connect(null, mapDispatch);

export default withConnect(DrawerAction);
